// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import './assets/tailwind.css'; // tailwind.css 파일 불러오기
import Vuetify from 'vuetify';
import router from './router';
import VeeValidate from 'vee-validate';
import Truncate from 'lodash.truncate';
import axios from 'axios';
import moment from 'moment';
import momentTime from 'moment-timezone';
import { sync } from 'vuex-router-sync';
import store from '@/store/store';
import '@mdi/font/css/materialdesignicons.css';
import VueCookies from 'vue-cookies';
// import DaySpanVuetify from 'dayspan-vuetify';
import { SchedulePlugin } from '@syncfusion/ej2-vue-schedule';
import colors from 'vuetify/es5/util/colors';
import i18n from '@/i18n/i18n';
import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons/iconfont/material-icons.css';
// import 'dayspan-vuetify/dist/lib/dayspan-vuetify.min.css';
import VueClipboard from 'vue-clipboard2';
import '../static/seoul/css/common.css';

// admin
import '../static/seoul/css/a_layout.css';
import '../static/seoul/css/a_common.css';
import '../static/seoul/css/a_popup.css';

import '@/lib/jquery.min.js';

import '@/lib/crypto.js';
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.config.productionTip = false;
// Helpers
// Global filters
Vue.filter('truncate', Truncate);
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(value).format('YYYY.MM.DD HH:mm');
  }
});

Vue.filter('formatDTime', function (value) {
  if (value) {
    return moment(value).format('YYYY.MM.DD HH:mm:ss');
  }
});

Vue.filter('formatDate2', function (value) {
  if (value) {
    return moment(value).format('YYYY.MM.DD');
  }
});

Vue.filter('formatDate3', function (value) {
  if (value) {
    return moment(value).format('YYYY.MM.DD');
  }
});

Vue.filter('formatTime', function (value) {
  if (value) {
    return momentTime(value).tz('Asia/Seoul').format('HH:mm');
  }
});

Vue.filter('numberToMoney', function (number) {
  if (number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    return 0;
  }
});

Vue.use(VeeValidate, { fieldsBagName: 'formFields' });
Vue.use(Vuetify, {
  theme: {
    primary: '#F89B6C', // colors.blue,
    secondary: '#F37321', // colors.indigo, // '#6CBF49',
    accent: colors.pink,
    tertiary: '#937B6E',
    quaternary: '#7A7A7A',
    quinary: '#464646',
    checkColor: '#F44336',
    gridBtnColor: '#7D5F3C',
  },
  options: {
    themeVariations: [
      'primary',
      'secondary',
      'accent',
      'tertiary',
      'quaternary',
      'quinary',
      'checkColor',
      'gridBtnColor',
    ],
    extra: {
      mainToolbar: {
        color: 'primary',
      },
      sideToolbar: {},
      sideNav: 'primary',
      mainNav: 'primary lighten-1',
      bodyBg: '',
    },
  },
});

// Vue.use(DaySpanVuetify, {
//   methods: {
//     getDefaultEventColor: () => '#1976d2'
//   }
// });
Vue.use(SchedulePlugin);
Vue.use(VueCookies);
// Vue.use(Dialog, { dialogBtnColor: '#0f0' });

// sync(store, router);
const axiosInstance = axios;
axiosInstance.interceptors.request.use(
  async (config) => {
    config.url = `${config.url}${
      config.url.includes('?') ? `&` : `?`
    }timestamp=${moment().unix()}`;
    return config;
  },
  (error) => Promise.reject(error)
);
Vue.prototype.$http = axiosInstance;
// Vue.prototype.$http = axios;
Vue.prototype.$flag = true;
Vue.prototype.$window = window;
Vue.prototype.$CryptoJS = window.CryptoJS;
Vue.prototype.$MvApi = window.MvApi;
Vue.prototype.$BodaApp = window.BodaApp;
Vue.prototype.$bandiJS = window.bandiJS;
// Bootstrap application components

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js